import { render, staticRenderFns } from "./viewShipment.vue?vue&type=template&id=45a486a7"
import script from "./viewShipment.vue?vue&type=script&lang=js"
export * from "./viewShipment.vue?vue&type=script&lang=js"
import style0 from "./viewShipment.vue?vue&type=style&index=0&id=45a486a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports